'use client';

import { useEffect } from 'react';

import { initMetaPixel } from '~/lib/analytics/meta-pixel';

import { useCookieConsent } from '../../../_components/cookie-consent-context';

/**
 * Map of vertical slugs to their Meta Pixel IDs.
 * Reads from NEXT_PUBLIC_*_PIXEL_ID env vars at build time.
 */
const VERTICAL_PIXEL_IDS: Record<string, string | undefined> = {
  drivers: process.env.NEXT_PUBLIC_DRIVERS_PIXEL_ID,
  'ballee-flow': process.env.NEXT_PUBLIC_BALLEE_PIXEL_ID,
  spitex: process.env.NEXT_PUBLIC_SPITEX_PIXEL_ID,
};

interface MetaPixelInitProps {
  verticalSlug: string;
}

/**
 * Initializes the Meta Pixel for a specific vertical.
 * Renders nothing. Must be placed inside a client boundary.
 *
 * Consent-gated on the marketing category. Exempt jurisdictions (e.g.
 * drivers/POPIA, via CookieConsentExemption in this layout) grant the
 * category automatically, so their pixels keep firing on first paint;
 * consent-requiring verticals (e.g. spitex/DSG) fire only after opt-in.
 */
export function MetaPixelInit({ verticalSlug }: MetaPixelInitProps) {
  const { marketing } = useCookieConsent();

  useEffect(() => {
    const pixelId = VERTICAL_PIXEL_IDS[verticalSlug];

    if (marketing && pixelId) {
      initMetaPixel(pixelId);
    }
  }, [marketing, verticalSlug]);

  return null;
}
